module.exports = __webpack_public_path__ + "static/media/cssart.949a49b4.jpg";